import Api from '@/services/Api'

export default {
  getList () {
    return Api().get('/mekke/')
  },

  get (servername) {
    return Api().get('/mekke/' + servername)
  },

  updatePassword (servername, password) {
    return Api().patch('/mekke/' + servername, {password: password})
  }
}
